export default __webpack_public_path__ + "static/logo3-f5654799e995c94a5ccdfa10dbdcb4f9.svg";